import { Card, CircularProgress } from "@mui/material";
import { useRCAHistoryMainStyles, useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import { RCALibraryHistoryLogItem } from "./component";
import { StatusEntity } from "entities/RCA/StatusEntity/StatusEntity";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { IHistoryLogRCA } from "entities/RCA/RCALibraryEntity/RCALibraryEntityInterfaces";

export const RCALibraryHistoryLogs = ({ logs, loadingLogs }: { logs: IHistoryLogRCA[]; loadingLogs: boolean }) => {
    const classes = useRCAHistoryMainStyles();
    const mainClasses = useRCAMainStyles();
    const { t } = useTranslation();

    const { statuses, loading: loadingStatusesOptions } = StatusEntity.GetStatuses();

    const historyLogs = useMemo(() => {
        if (loadingStatusesOptions || loadingLogs) {
            return (
                <div className={classes.cardContentLoading}>
                    <CircularProgress color="info" />
                </div>
            );
        }
        return (
            <div className={classes.cardContent}>
                {logs.map((log) => (
                    <RCALibraryHistoryLogItem log={log} key={log.history_id} statuses={statuses} />
                ))}
            </div>
        );
    }, [loadingStatusesOptions, loadingLogs, logs, classes, statuses]);

    return (
        <Card className={`${mainClasses.contentCard} ${classes.card}`}>
            <div className={mainClasses.contentCardHeader}>
                <div className={mainClasses.contentCardTitle}>{t("rca.history_audit_logs.title")}</div>
            </div>
            {historyLogs}
        </Card>
    );
};
